import { type RefObject } from 'react';
import { type ScrollView } from 'react-native';
import { type SharedValue } from 'react-native-reanimated';

// ─────────────────────────────────────────────────────────────────────────────

export type Context = {
  activeTargetId: string | null;
  defaultTargetId: string | null;
  programmaticTargetY: number | null;
  scrollOffset: SharedValue<number>;
  scrollViewRef: RefObject<{
    scrollTo: (options: { y: number; animated: boolean }) => void;
  } | null>;
  navScrollViewRef: RefObject<ScrollView | null>;
  measurements: Record<string, TargetMeasurement>;
  targetRefs: Record<string, RefObject<unknown>>;
  scrollViewDimensions: { contentHeight: number; viewportHeight: number };
};

export type TargetMeasurement = { y: number; height: number };
